import React, { SFC } from "react";
import { HelpDialog } from "./HelpDialog";

interface HelpDialogProps {
  defaultSelectedCategoryIndex: number;
  defaultSelectedItemInCategoryIndex: number;
}

interface HelpDialogContextProps {
  openDialog(props?: HelpDialogProps): void;
}
const HelpDialogContext = React.createContext<HelpDialogContextProps>({ openDialog() {} });

export interface Props {}

export const HelpDialogProvider: SFC<Props> = ({ children }) => {
  const [helpDialogProps, setHelpDialogProps] = React.useState<HelpDialogProps>();
  const handleClose = React.useCallback(() => {
    setHelpDialogProps(undefined);
  }, [setHelpDialogProps]);

  const handleOpen = React.useCallback(
    (props = {}) => {
      setHelpDialogProps(props);
    },
    [setHelpDialogProps]
  );

  return (
    <HelpDialogContext.Provider value={{ openDialog: handleOpen }}>
      <>
        {helpDialogProps && <HelpDialog {...helpDialogProps} onClose={handleClose} />}
        {children}
      </>
    </HelpDialogContext.Provider>
  );
};

HelpDialogProvider.displayName = "HelpDialogProvider";

export const useHelpDialogContext = () => React.useContext(HelpDialogContext);
